import { useEffect } from 'react';
import { authApi } from '../auth/authApi';

/**
 * Sends a heartbeat to the server every `interval` ms while the user is logged in.
 * This keeps the server's `onlineAt` timestamp fresh (used for party online checks).
 */
export function useHeartbeat(token: string | null, interval = 20_000): void {
  useEffect(() => {
    if (!token) return;

    // Fire once immediately so the user appears online right away
    authApi.heartbeat(token).catch(() => { /* ignore — server is just offline */ });

    const id = setInterval(() => {
      authApi.heartbeat(token).catch(() => { /* ignore */ });
    }, interval);

    return () => clearInterval(id);
  }, [token, interval]);
}
